<script lang="ts">
  import type {Notification, User} from '../types'
  import {t, replaceValues} from '../i18n'
  import {Link} from 'svelte5-router'
  import {formatDateTimeRelative} from '../utils/format'

  export let notificationParams: {follower: User}
  export let notification: Notification

  $: follower = notificationParams.follower
</script>

<Link class="item" to={follower.link}>
  <div class="notice-img">
    <img src={follower.avatar_big_thumgb} alt={follower.full_name}/>
  </div>
  <div class="notice-content">
    <span class="notice-action db">
      {@html replaceValues(t.timelines.user_followed, {user: follower.full_name, user_id: follower.id})}
    </span>
    <i class="notice-time db">{formatDateTimeRelative(notification.created_at)}</i>
  </div>
</Link>